import { PausedService } from './paused-service.node'
import { rootMethods } from './root-methods'

export const pausedService = {
  PausedService,
  rootMethods
}